module.exports = __webpack_public_path__ + "static/img/knowledge.4755b0ae.png";